import React, { useEffect, type FC } from 'react'
import { useAtomCallback } from 'jotai/utils'

import {
  Flex,
  ToastContainer,
  Panel,
  Divider,
  Text,
} from 'mailup-web-components'
import Page from 'Containers/Page'

import Header from './components/Header'
import { initPageCallback, resetPageCallback } from './callbacks/page'
import Search from './components/Search'
import { CategoriesList } from './components/CategoriesList'
import ActionAddCategory from './components/ActionAddCategory'
import { CategoryForm } from './components/CategoryForm'
import ModalDeleteCategory from './components/ModalDeleteCategory'
import { useIntl } from 'react-intl'

const NewCategoriesListPage: FC = () => {
  const intl = useIntl()
  const initPage = useAtomCallback(initPageCallback)
  const resetPage = useAtomCallback(resetPageCallback)

  useEffect(() => {
    void initPage()
    return resetPage
  }, [initPage, resetPage])

  return (
    <>
      <Header />
      <Page onReload={resetPage}>
        <ToastContainer />
        <ModalDeleteCategory />
        <CategoryForm />
        <Flex flexDirection='column' gap='24px'>
          <Text>
            {intl.formatMessage({
              id: 'Load.FiltersCategories.CategoriesDescription',
            })}
          </Text>
          <Search />
          <Panel>
            <Flex flexDirection='column' gap='8px'>
              <ActionAddCategory />
              <Divider negativeMarginX={32} />
              <div />
              <CategoriesList />
            </Flex>
          </Panel>
        </Flex>
      </Page>
    </>
  )
}

export default NewCategoriesListPage
